import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import TextField from '@atlaskit/textfield';
import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl-next';
import { css, jsx } from '@emotion/react';
import ColorPalette from './internal/color-palette';
import { messages } from './i18n';
var fieldTextWrapperStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 ", ";\n"])), "var(--ds-space-100, 8px)");
var Picker = /*#__PURE__*/function (_PureComponent) {
  _inherits(Picker, _PureComponent);
  var _super = _createSuper(Picker);
  function Picker() {
    var _this;
    _classCallCheck(this, Picker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "fieldTextWrapperKey", Math.random().toString());
    _defineProperty(_assertThisInitialized(_this), "colorPaletteKey", Math.random().toString());
    _defineProperty(_assertThisInitialized(_this), "onChange", function (evt) {
      // @ts-ignore
      _this.props.onTextChanged(evt.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (event) {
      if (event.key === 'Enter') {
        _this.props.onEnter();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleInputRef", function (ref) {
      _this.inputRef = ref;
      if (ref && _this.props.autoFocus) {
        _this.focusInput();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "focusInput", function () {
      if (!_this.inputRef) {
        return;
      }
      // Defer to prevent editor scrolling to top
      _this.autofocusTimeout = setTimeout(function () {
        var _this$inputRef;
        (_this$inputRef = _this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.focus();
      });
    });
    return _this;
  }
  _createClass(Picker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        text = _this$props.text,
        selectedColor = _this$props.selectedColor,
        onColorClick = _this$props.onColorClick,
        onColorHover = _this$props.onColorHover,
        intl = _this$props.intl;

      // Using <React.Fragment> instead of [] to workaround Enzyme
      // (https://github.com/airbnb/enzyme/issues/1149)
      return jsx(React.Fragment, null, jsx("div", {
        css: fieldTextWrapperStyles,
        key: this.fieldTextWrapperKey
      }, jsx(TextField, {
        value: text,
        isCompact: true,
        ref: this.handleInputRef,
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        spellCheck: false,
        autoComplete: "off",
        "aria-label": intl.formatMessage(messages.statusInputLabel)
      })), jsx(ColorPalette, {
        key: this.colorPaletteKey,
        onClick: onColorClick,
        onHover: onColorHover,
        selectedColor: selectedColor
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.inputRef && this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.autofocusTimeout !== undefined) {
        clearTimeout(this.autofocusTimeout);
      }
    }
  }]);
  return Picker;
}(PureComponent);
_defineProperty(Picker, "defaultProps", {
  autoFocus: true
});
export var StatusPicker = injectIntl(Picker);